"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoSource = void 0;
const typebox_1 = require("@sinclair/typebox");
const VideoSourceBase = typebox_1.Type.Object({
    drmEnabled: typebox_1.Type.Optional(typebox_1.Type.Boolean({
        title: 'Is DRM protected',
        description: 'If true, the video will be protected by a DRM license. Digital Rights Management (DRM) is a digital license system that allows content creators and distributors to control who can use their content, and how they can use it. ',
        default: false,
    })),
    serversideForensic: typebox_1.Type.Optional(typebox_1.Type.Boolean({
        title: 'Has Serverside Forensic',
        description: 'If checked, the video is protected by Serverside Forensic Watermarking.',
        default: false,
    })),
});
const Hls = typebox_1.Type.Object({
    hls: typebox_1.Type.String({ title: 'HLS' }),
    ...VideoSourceBase.properties,
}, { $id: 'HLS' });
const Dash = typebox_1.Type.Object({
    dash: typebox_1.Type.String({ title: 'DASH' }),
    ...VideoSourceBase.properties,
}, { $id: 'DASH' });
const HlsDash = typebox_1.Type.Object({
    hls: typebox_1.Type.String({ title: 'HLS' }),
    dash: typebox_1.Type.String({ title: 'DASH' }),
    ...VideoSourceBase.properties,
}, { $id: 'HLSDASH' });
const Progressive = typebox_1.Type.Object({
    progressive: typebox_1.Type.String({ title: 'Progressive' }),
}, { $id: 'Progressive' });
exports.VideoSource = typebox_1.Type.Union([Dash, Hls, HlsDash, Progressive]);
